module.exports = __webpack_public_path__ + "static/mary-kay-3-17beb8e07c0791fc9ce675f50232d721.jpg";